import { render, staticRenderFns } from "./ContractsPanel.vue?vue&type=template&id=7a0b9f4b&scoped=true&"
import script from "./ContractsPanel.vue?vue&type=script&lang=ts&"
export * from "./ContractsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsPanel.vue?vue&type=style&index=0&id=7a0b9f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b9f4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
